export const EXAMPLE_QUESTIONS = [
  "What is the long-term efficacy of GLP-1 receptor agonists for weight management in adults without diabetes?",
];

export default EXAMPLE_QUESTIONS;
